import { motion, useInView } from "framer-motion"
import { useRef } from "react"

const ScrollAnimate = ({children, delay = 0.2, once = true, amount = 0.2, className = ''}) => {
  const ref = useRef(null)
    const inView = useInView(ref, {
      once,
      amount
    });

    const animation = {
      hidden: { opacity: 0, y: 150 },
      visible: { opacity: 1, y: 0 },
    };

    return (
      <div ref={ref} className={className}>
        <motion.div
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={animation}
          transition={{
            duration: 0.5,
            delay,
            ease: "easeOut",

          }}
        >
          {children}
        </motion.div>
      </div>
    );
  };

  export default ScrollAnimate;
